import { UserIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const User = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <UserIcon size={Sizes[size]} {...rest} />;
};

User.displayName = 'UserSquare';
